/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_ClientInputs */

const en_mk_foot_client = /** @type {(inputs: Mk_Foot_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client portal`)
};

const id_mk_foot_client = /** @type {(inputs: Mk_Foot_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal klien`)
};

/**
* | output |
* | --- |
* | "Client portal" |
*
* @param {Mk_Foot_ClientInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_client = /** @type {((inputs?: Mk_Foot_ClientInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_ClientInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_client(inputs)
	return en_mk_foot_client(inputs)
});